import { gql } from "@apollo/client";

const SYNC_LOCATION = gql`
  mutation syncLocation {
    syncLocation {
      status
      data
      error
    }
  }
`;

export default SYNC_LOCATION;
